exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.checkout-btn[data-v-3294336d] {\n  width: 160px;\n  height: 36px;\n  border-radius: 4px;\n  border: solid 1px #e5e5e5;\n  color: #ffffff;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3294336d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/check-out/CheckoutByCard.vue
// module id = 474
// module chunks = 1